import { keyBy } from "lodash";

import {
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(6133): 'DEFAULT_HTML_TEMPLATE' is declared but its value ... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  DEFAULT_HTML_TEMPLATE,
  DEFAULT_PLAINTEXT_TEMPLATE,
  DUMMY_TEMPLATE_ID,
} from "constants/settings/emailTemplates";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";
import { IActionWithPayload } from "store/helper";

import { IEntityCreateSuccess, IEntityFetchCollectionSuccess, IEntityUpdateSuccess } from "../actions";

import { EmailTemplateAction, EmailTemplateActionNames } from "./actions";
import { IEmailTemplate } from "./interfaces";

const initialState = {
  data: {},
  preview: {
    isLoading: true,
    isError: false,
    data: { text: "", html: "" },
  },
};

export interface IEmailTemplatesState {
  data: IEntityCollectionState<IEmailTemplate>;
  preview: {
    isLoading: boolean;
    isError: boolean;
    data: { text: string; html: string };
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const emailTemplatesReducer = (state: IEmailTemplatesState = initialState, action: EmailTemplateAction) => {
  switch (action.type) {
    case EmailTemplateActionNames.UPDATE_EMAIL_TEMPLATE_SUCCESS: {
      const payload = action.payload as IEntityUpdateSuccess<IEmailTemplate>;

      return { ...state, data: { ...state.data, [payload.id]: payload.value } };
    }
    case EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_SUCCESS: {
      const payload = action.payload as IEntityFetchCollectionSuccess<IEmailTemplate> & { defaultHtmlTemplate: string };

      if (payload.values.length === 0) {
        const newState = {
          [DUMMY_TEMPLATE_ID]: {
            id: DUMMY_TEMPLATE_ID,
            createdAt: new Date(),
            createdBy: "00000000-0000-4000-0000-000000000000",
            createdByType: "system",
            updatedAt: new Date(),
            updatedBy: "00000000-0000-4000-0000-000000000000",
            updatedByType: "system",
            licenseID: 12345678,
            name: "Default template",
            content: {
              text: DEFAULT_PLAINTEXT_TEMPLATE,
              html: payload.defaultHtmlTemplate,
            },
          },
        };

        return { ...state, data: newState };
      }

      const newState = keyBy(payload.values, template => template.id);
      return { ...state, data: newState };
    }
    case EmailTemplateActionNames.FETCH_PREVIEW_REQUEST: {
      return {
        ...state,
        preview: {
          isLoading: true,
          isError: false,
          data: { text: "", html: "" },
        },
      };
    }
    case EmailTemplateActionNames.FETCH_PREVIEW_SUCCESS: {
      const { payload } = action as IActionWithPayload<string, { text: string; html: string }>;

      return {
        ...state,
        preview: {
          isLoading: false,
          isError: false,
          data: payload,
        },
      };
    }
    case EmailTemplateActionNames.FETCH_PREVIEW_FAILURE: {
      return {
        ...state,
        preview: {
          isLoading: false,
          isError: true,
          data: { text: "", html: "" },
        },
      };
    }
    case EmailTemplateActionNames.CREATE_EMAIL_TEMPLATE_SUCCESS: {
      const payload = action.payload as IEntityCreateSuccess<IEmailTemplate>;

      const data = { ...state.data };

      if (data[DUMMY_TEMPLATE_ID]) {
        delete data[DUMMY_TEMPLATE_ID];
      }
      return {
        ...state,
        data: {
          ...data,
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          [payload.value.id]: payload.value,
        },
      };
    }
    default:
      return state;
  }
};
